import { useEffect, useState } from "react";
import { Col } from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { API } from "../../config/api";
import {FaPlus, FaPlusCircle, FaCog, FaTimesCircle, FaShieldAlt, FaSync, FaQrcode} from 'react-icons/fa'
import ReactPaginate from "react-paginate";
import "bulma/css/bulma.css";
import "../../index.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
// Modal Role
import ModalAddMedis from "./ModalAdmin/ModalAdd"
import ModalUpdateMedis from "./ModalAdmin/ModalUpdate"
import ModalViewBarcode from "./ModalAdmin/ModalViewBarcode"
import LoaderHome from "../Loader/LoaderHome"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function Login() {
  // let navigate = useNavigate();
  // useEffect(() => {
  //   if (localStorage.getItem("token") == null || undefined) {
  //       navigate("/");
  //     }
  // }, []);
  document.title = "Patrol Log Check Point";
  const [getData, setGetData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState();
  const [ascending, setAscending] = useState(0);
  const [rows, setRows] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const [msg, setMsg] = useState("");
  const token = localStorage.getItem("token");
  // Responsive to mobile or dekstop
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)'})
  // modal role add 
  const [id, setId] = useState();
  const [namePosUpdate, setNamePosUpdate] = useState();
  const [typePosUpdate, setTypePosUpdate] = useState();
  const [locationUpdate, setLocationUpdate] = useState();
  const [latitudeUpdate, setLatitudeUpdate] = useState();
  const [longitudeUpdate, setLongitudeUpdate] = useState();
  const [noteUpdate, setNoteUpdate] = useState();
  const [nameViewQr, setNameViewQr] = useState();
  const [imageUrl, setImageUrl] = useState();
  const [modalAdd, setModalAdd] = useState(false);
  const [viewBarCode, setViewBarcode] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nameRole, setNameRole] = useState("security");
  const [getDataTotalSecurity, setGetDataToltalSecurity] = useState([]);

  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };

  const [form, setForm] = useState({
    date_check_first: "",
    date_check_last: "",
    id_security: "",
    date_check_today: ""
  });

  const GetResponseDataSecurity = async () => {
    try {
      const response = await API.get(`/api/security?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&name_role=${nameRole}`,fetchParams)
      if (response?.status === 200) {
        setGetDataToltalSecurity(response.data.data)
        }
    } catch (error) {
    
    }
  }

  const GetResponseData = async () => {
    try {
      // e.preventDefault();
      // setLoading(true)
      const date_check_today = new Date().toISOString().split('T')[0];
      const response = await API.get(`/api/check-point-logs?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&date_check_first=${form?.date_check_first}&date_check_last=${form?.date_check_last}&id_security=${form?.id_security}&date_check_today=${date_check_today}`,fetchParams)

      // Checking process
      if (response?.status === 200) {
        setGetData(response.data.data)
        setPage(response.data.pagination.current_page);
        setPages(response.data.pagination.total_pages);
        setRows(response.data.pagination.total);
        // setLoading(false)
        }
    } catch (error) {
      // setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  useEffect(() => {
    GetResponseDataSecurity()
  },[])

  useEffect(() => {
    GetResponseData()
  },[page,keyword,limit])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setKeyword(query);
    }, 300); 

    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  const changePage = ({ selected }) => {
    setPage(selected+1);
    if (selected === 10) {
      setMsg(
        ""
      );
    } else {
      setMsg("");
    }
  };

  const handleDateChangeFirst = (date) => {
    const formattedDate = formatDate(date);
    setForm({
      ...form,
      date_check_first: formattedDate,
    });
  };
  
  const handleDateChangeLast = (date) => {
    const formattedDate = formatDate(date);
    setForm({
      ...form,
      date_check_last: formattedDate,
    });
  };
  
  const handleChange = async (e) => {
    setForm({
      ...form,
      [e.target.name] : e.target.value,
    });
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  };

  const deleteById = async (id) => {
    Swal.fire({
      title: 'Apakah Kamu Yakin?',
      text: `Menghapus data ini`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus'
    }).then( async (result) => {
      if(result.isConfirmed) {
        const response =  await API.delete(`transaction-service/rooms/${id}`,fetchParams);
        if (response.data.error == false) {
          GetResponseData()
          swal({
            title: 'Success',
            text: "Your data has been successfully deleted",
            icon: 'success',
            timer: 3000,
            buttons: false
          });
        }  
      }
    })
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeyword(query);
  };

  const initialFormState = {
    date_check_first: "",
    date_check_last: "",
    id_security: "",
  };

  const resetForm = () => {
    setForm(initialFormState);
  };

  const buttonRefresh = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    resetForm();
  }
  
  const viewModalAdd = () => {
    setModalAdd(true)
  }

  const viewModalUpdate = (id, name_pos, type_pos, location, latitude, longitude, note) => {
    setModalUpdate(true)
    setId(id)
    setNamePosUpdate(name_pos)
    setTypePosUpdate(type_pos)
    setLocationUpdate(location)
    setLatitudeUpdate(latitude)
    setLongitudeUpdate(longitude)
    setNoteUpdate(note)
  }

  const viewModalQr = (id, name_pos, image_url ) => {
    setViewBarcode(true)
    setId(id)
    setNameViewQr(name_pos)
    setImageUrl(image_url)
  }

  return (
    <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
      {modalAdd  && <ModalAddMedis GetResponseData={GetResponseData} show={modalAdd} onHide={() => setModalAdd(false)} />}
      {modalUpdate && <ModalUpdateMedis GetResponseData={GetResponseData} namePosUpdate={namePosUpdate} typePosUpdate={typePosUpdate} 
      locationUpdate={locationUpdate} latitudeUpdate={latitudeUpdate} longitudeUpdate={longitudeUpdate} noteUpdate={noteUpdate} 
      id={id} show={modalUpdate} onHide={() => setModalUpdate(false)} />}
      {viewBarCode  && <ModalViewBarcode  id={id} nameViewQr={nameViewQr} imageUrl={imageUrl} show={viewBarCode} onHide={() => setViewBarcode(false)} />}
      {loading && <LoaderHome />}
      
      {isTabletOrMobile ? 
        <div style={{ paddingLeft: "0px", width: "100%", borderBottom: "5px solid #EEEEEE", display: "", padding: "0px 0px 10px 0px" }}>
          <Col xl="6" style={{fontSize:"16px",display:"flex", justifyContent:"center", alignItems:"center", padding:"7px", color:"white", backgroundColor:"#005A9F"}}>
              <FaShieldAlt style={{marginRight:"5px"}}/>Log Check Point
          </Col>
          {/* <Col className="mt-2" xl="6" style={{ display: "flex", justifyContent:"end", paddingRight:"5px" }}>
            <div onClick={viewModalAdd} style={{display:"flex",alignItems:"center",marginRight:"5px",backgroundColor:"#3D64FF",color:"white",padding:"0px 12px", borderRadius:"3px", cursor:"pointer", fontSize:"12px", cursor:"pointer"}}>
              <FaPlus/>
            </div>
            <div onClick={buttonRefresh} style={{ height: "100%", marginRight: "5px", paddingTop: "0px", backgroundColor: "white", padding: "10px 10px", borderRadius: "2px", cursor: "pointer", border: "1px solid #DEDEDE" }}>
              <FaSync style={{ fontSize: "15px", marginRight: "0px", marginTop: "0px", display: "flex", alignItems: "center", height:"100%", color:"#3D64FF" }} />
            </div>
            <form onSubmit={searchData} style={{display:"flex", paddingRight:"0px"}}>
                <div style={{marginRight:"5px",borderRadius:"3px"}}>
                  <input value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    className="focused"
                    style={{backgroundColor:"#E9E9E9", border:"none",height:"100%"}}
                    type="text"
                    placeholder="testing"
                  />
              </div>
                <button type="submit"  style={{ border: "none", backgroundColor: "#3D64FF", color: "white", display: "flex", borderRadius:"2px", fontWeight:"600", fontSize:"12px",alignItems:"center", padding:"0px 10px" }}>
                  Search
                </button>
            </form>
          </Col> */}
        </div>
          :
        <div style={{ paddingLeft: "0px", width: "100%", borderBottom: "5px solid #EEEEEE", display: "flex", padding: "10px 20px 10px 0px",backgroundColor:"#005A9F", borderRadius:"5px" }}>
          <div style={{flex:"50%",fontSize:"16px",display:"flex", alignItems:"center", paddingLeft:"10px", color:"white"}}>
            <FaShieldAlt style={{marginRight:"5px"}}/>Log Check Point
          </div>
          {/* <div style={{ flex: "50%", display: "flex", justifyContent:"end" }}>
            <div className="mr-2" style={{display:"flex",alignItems:"center",marginRight:"5px",backgroundColor:"white",color:"black", borderRadius:"3px", cursor:"pointer", fontSize:"12px"}}>
          
            </div>
            <div onClick={viewModalAdd} style={{display:"flex",alignItems:"center",marginRight:"5px",backgroundColor:"white",color:"#005A9F",padding:"8px 10px", borderRadius:"3px", cursor:"pointer", fontSize:"12px", cursor:"pointer"}}>
              <div>
                <FaPlusCircle/> &nbsp;
              </div>
              <div>
                Tambah Security
              </div>
            </div>
          </div> */}
        </div>  
      }

      {isTabletOrMobile ? 
        <div style={{display: "flex", padding: "10px 0px 10px 0px",
          backgroundColor:"", justifyContent:"end" }}>
        <div style={{ display: "flex", justifyContent:"" }}>
          {/* <div onClick={buttonRefresh} style={{ height: "100%", marginRight: "5px", paddingTop: "0px", backgroundColor: "white", padding: "0px 10px", border: "1px solid #DEDEDE", borderRadius: "3px", cursor: "pointer" }}>
              <FaSync style={{ fontSize: "15px", marginRight: "0px", marginTop: "0px", display: "flex", alignItems: "center", height:"100%", color:"#3D64FF" }} />
            </div> */}
          <div className="mr-1">
            <DatePicker
              selected={form.date_check_first ? new Date(form.date_check_first) : null}
              onChange={handleDateChangeFirst}
              name="date_check_first"
              dateFormat="dd/MM/yyyy"
              placeholderText="Awal"
              className="form-control"
            />
          </div>

          <div className="mr-1">
            <DatePicker
                selected={form.date_check_last ? new Date(form.date_check_last) : null}                
                onChange={handleDateChangeLast}
                name="date_check_last"
                dateFormat="dd/MM/yyyy"
                placeholderText="Akhir"
                className="form-control"
            />
          </div>

          <div className="mr-1" style={{ display: ""}}>
            <select className="form-select" aria-label="Default select example" value={form?.id_security} onChange={handleChange} name="id_security" style={{ textAlign: "", cursor: "pointer" }}>
              <option value="">- Petugas -</option>   
              {getDataTotalSecurity.map((user,index) => (
                  <option value={user?.id} style={{textAlign:""}}>{user?.firstname} {user?.lastname}</option>
                ))}  
            </select>
          </div>

          <form onSubmit={searchData} style={{display:"flex"}}>
            <button type="submit" className="mr-1"  style={{ border: "none", backgroundColor: "#005A9F", color: "white", display: "flex", borderRadius:"3px", fontWeight:"600", fontSize:"12px",alignItems:"center", padding:"0px 10px" }}>
              Search
            </button>
          </form>
        </div>
        </div> 
          :
        <div style={{display: "flex", padding: "10px 5px 10px 0px"}}>
          <div style={{flex:"20%", display:"flex"}}>
            <div style={{display:"flex",fontSize:"16px", alignItems:"center", paddingLeft:"10px", color:"black"}}>
              <div>
                Show
              </div>
              &nbsp;
              <div>
              <select
                className="form-select"
                aria-label="Default select example"
                style={{ textAlign: "", cursor: "pointer", height: "35px" }}
                onChange={(e) => setLimit(e.target.value)}
                value={limit}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              </div>
              &nbsp;
              <div>
                Entries
              </div>
            </div>
          </div>
          <div style={{ flex: "80%", display: "flex", justifyContent:"end" }}>
          {/* <div onClick={buttonRefresh} style={{ height: "100%", marginRight: "5px", paddingTop: "0px", backgroundColor: "white", padding: "0px 10px", border: "1px solid #DEDEDE", borderRadius: "3px", cursor: "pointer" }}>
              <FaSync style={{ fontSize: "15px", marginRight: "0px", marginTop: "0px", display: "flex", alignItems: "center", height:"100%", color:"#3D64FF" }} />
            </div> */}
          <div className="mr-1">
            <DatePicker
              selected={form.date_check_first ? new Date(form.date_check_first) : null}
              onChange={handleDateChangeFirst}
              name="date_check_first"
              dateFormat="dd/MM/yyyy"
              placeholderText="Awal"
              className="form-control"
            />
          </div>

          <div className="mr-1">
            <DatePicker
                selected={form.date_check_last ? new Date(form.date_check_last) : null}                
                onChange={handleDateChangeLast}
                name="date_check_last"
                dateFormat="dd/MM/yyyy"
                placeholderText="Akhir"
                className="form-control"
            />
          </div>

          <div className="mr-1" style={{ display: ""}}>
            <select className="form-select" aria-label="Default select example" value={form?.id_security} onChange={handleChange} name="id_security" style={{ textAlign: "", cursor: "pointer" }}>
              <option value="">- Petugas -</option>   
              {getDataTotalSecurity.map((user,index) => (
                  <option value={user?.id} style={{textAlign:""}}>{user?.firstname} {user?.lastname}</option>
                ))}  
            </select>
          </div>

          <form onSubmit={searchData} style={{display:"flex"}}>
            <button type="submit"   style={{ border: "none", backgroundColor: "#005A9F", color: "white", display: "flex", borderRadius:"3px", fontWeight:"600", fontSize:"12px",alignItems:"center", padding:"0px 10px" }}>
              Search
            </button>
          </form>
        </div>
        </div> 
      }

      {isTabletOrMobile ? 
        <div style={{display: "flex", padding: "10px 20px 10px 0px",
          backgroundColor:"", justifyContent:"end" }}>
          <div style={{display:"flex",fontSize:"16px", alignItems:"center", paddingLeft:"10px", color:"black"}}>
            <div>
              Show
            </div>
            &nbsp;
            <div>
            <select
              className="form-select"
              aria-label="Default select example"
              style={{ textAlign: "", cursor: "pointer", height: "35px" }}
              onChange={(e) => setLimit(e.target.value)}
              value={limit}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            </div>
            &nbsp;
            <div>
              Entries
            </div>
          </div>
        </div> 
          :
        <div style={{display: "flex", padding: "10px 20px 10px 0px"}}>
         
        </div> 
      }
    
      <Col xl='12' sm='12'> 
      <div>
        <div style={{display:"block", height:"100%", overflowY:"auto",overflowX:"auto"}}>
          <div >
            <table className="table dt-responsive nowrap w-100" id="basic-datatable">
              <thead>
                <tr style={{backgroundColor: isTabletOrMobile? "white" : "white", borderBottom:"1px solid #BCBCBC"}}>
                  {/* <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>No</th> */}
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Tanggal</th>
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Waktu</th>
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Nama Petugas</th>
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Nama Titik</th>
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Lokasi</th>
                  {/* <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Foto Selfie</th> */}
                  {/* <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Tanggal</th> */}
                  {/* <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Barcode</th> */}
                  <th style={{ fontFamily: "revert", fontSize: "12px", textAlign: "center", color: "#525252", border: "none", fontFamily: "sans-serif" }}>Note</th>
                  {/* <th style={{ fontFamily:"revert", fontSize:"12px",textAlign:"center", color:"#525252",border:"none", fontFamily:"sans-serif"}}>Action</th> */}
                </tr>
              </thead>
              <tbody>
                  {getData.map((user,index) => (
                    <tr key={index} style={{fontFamily:"Poppins", fontSize:"11px", textAlign:"center"}}>
                      <td style={{ lineHeight: "2" }}>
                        <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          <div>
                            {user?.date_check}
                          </div> 
                        </div>
                      </td>
                      <td style={{ lineHeight: "2" }}>
                        <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          <div>
                            {user?.time_check}
                          </div> 
                        </div>
                      </td>
                      {/* <td style={{ lineHeight: "2" }}>
                        <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          <div>
                            {user?.type_pos}
                          </div> 
                        </div>
                      </td> */}
                      <td style={{ lineHeight: "2" }}>
                        <div style={{display:"flex", alignItems:"", justifyContent:""}}>
                          <div>
                            {user?.name_security}
                          </div> 
                        </div>
                      </td>
                      <td style={{ lineHeight: "2" }}>
                        <div style={{display:"flex", alignItems:"center", justifyContent:""}}>
                          <div>
                            {user?.name_pos}
                          </div> 
                        </div>
                      </td>
                      <td style={{ lineHeight: "2" }}>
                        <div style={{display:"flex", alignItems:"center", justifyContent:""}}>
                          <div>
                            {user?.location}
                          </div> 
                        </div>
                      </td>
                      
                      {/* <td style={{lineHeight:"1"}}>
                        <div style={{display:"flex",justifyContent:"center", alignItems:"center", alignContent:"center"}}>
                          <button onClick={() => viewModalQr(user?.id_qr_code, user?.name_pos, user?.image_url)} style={{ fontSize: "17px", color: "#2196F3", backgroundColor: "white", borderRadius: "3px", cursor: "pointer", border: "none", display:"flex", marginRight:"3px" }}>
                            <FaQrcode/>
                          </button>
                        </div>
                      </td> */}
                      <td style={{ lineHeight: "2" }}>
                        <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          <div>
                            {user?.note}
                          </div> 
                        </div>
                      </td>
                      {/* <td style={{lineHeight:"1"}}>
                        <div style={{display:"flex",justifyContent:"center", alignItems:"center", alignContent:"center"}}>
                            <button onClick={() => viewModalUpdate(user?.id, user?.name_pos, user?.type_pos, user?.location, user?.latitude, user?.longitude, user?.note)} style={{ fontSize: "17px", color: "#2196F3", backgroundColor: "white", borderRadius: "3px", cursor: "pointer", border: "none", display:"flex", marginRight:"3px" }}>
                              <FaCog/>
                            </button>
                            <button onClick={() => {deleteById(user?.id)}} style={{ fontSize: "17px", color: "#dc3545", backgroundColor: "white",  borderRadius: "3px", cursor: "pointer", border: "none", display:"flex" }}>
                              <FaTimesCircle/>
                            </button>
                        </div>
                      </td> */}
                    </tr>
                  ))}
              </tbody>
            </table>
              
              </div>
            </div>
            </div>
            <div style={{ display: "flex", padding:"10px"}}>
          <div>
            <div style={{fontSize:"12px"}}>
              Total Rows: {rows} 
            </div>
            <div style={{fontSize:"12px"}}>
              Page: {rows ? page : 0} of {pages}
            </div>
            <p className="has-text-centered has-text-danger">{msg}</p>
          </div> 
            <div style={{flex:"50%", display:"flex", justifyContent:"end"}}>
              <nav
                style={{fontSize:"12px"}}
                className="pagination is-centered"
                key={rows}
                role="navigation"
                aria-label="pagination"
                >
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  pageCount={Math.min(10, pages)}
                  onPageChange={changePage}
                  containerClassName={"pagination-list"}
                  pageLinkClassName={"pagination-link"}
                  previousLinkClassName={"pagination-previous"}
                  nextLinkClassName={"pagination-next"}
                  activeLinkClassName={"pagination-link is-current"}
                  disabledLinkClassName={"pagination-link is-disabled"}
                />
              </nav>
              </div>
            </div> 
      </Col>

    </div>
  );
}
